export default {"src":"/_next/static/media/simple-spinner.87bd8715.gif","height":256,"width":256,"blurWidth":0,"blurHeight":0};